<template>
  <div>
    <el-header class="header" height="85px">
      <img
        class="header-image w4"
        align="left"
        src="@/assets/images/logo.png"
        alt=""
        srcset=""
        @click="$router.push('/')"
      />
      <span align="left">
        <el-input
          size="small"
          class="header-input"
          placeholder="Masukkan nomor Pesanan / Kiriman"
          v-model="searchOrderNumber"
          @keyup.enter.native="searchOrder"
        >
          <el-button
            slot="prepend"
            class="icon-search"
            @click="searchOrder"
          ></el-button>
        </el-input>
      </span>
      <span class="header-info">
        Customer:<span style="color: blue"> (021) 2927 8888 </span> Email:
        <span style="color: blue">customercare@fastanalogistic.com</span>
      </span>
    </el-header>

    <div class="common-header-nav">
      <!-- <span> -->
      <!-- <b>Dashboard</b>
        <span class="mh3">/</span> -->
      <b>Detail Pesanan / Kiriman</b>
      <!-- </span> -->
    </div>
    <div class="ph4 pv3 f5">
      <div class="orderDetail-header">
        <b>
          {{ order.shipmentGroupNo }}
        </b>
        <!-- <el-button size="mini" class="status-btn" :class="currentStatus">
          {{
            currentStatus ? $_strings.order.getStatusText(currentStatus) : ""
          }}
        </el-button> -->
        <el-row>
          <el-col span="8">
            <div>
              <br />
              <b class="f5">
                <!-- {{ order.transporterCompany}} -->
                Data Armada
              </b>
              <el-divider></el-divider>
            </div>
            <!-- <span class="label-text">Tanggal Pengiriman</span>
            <br />
            <span>{{ getDate(order.deliveryDate) }}</span> -->
            <div>
              <el-row class="mt2">
                <el-col :span="12">
                  <span class="label-text">Tipe Mobil</span>
                  <br />
                  <span>{{ order.transportType }}</span>
                </el-col>
                <el-col :span="12">
                  <span class="label-text">No Kendaran</span>
                  <br />
                  <span>{{ order.transportNo }}</span>
                </el-col>
              </el-row>
              <el-row class="mt2">
                <el-col :span="12">
                  <span class="label-text">Nama Sopir</span>
                  <br />
                  <span>{{ order.driverName }}</span>
                </el-col>
                <el-col :span="12">
                  <span class="label-text">Kontak Sopir</span>
                  <br />
                  <span v-text="replaceDetailNull(order.driverPhone)"></span>
                </el-col>
              </el-row>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
const { getDate } = require("../../helper/commonHelpers.js");
export default {
  name: "order-detail-header",
  props: {
    order: Object,
    currentStatus: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      searchOrderNumber: "",
    };
  },
  methods: {
    searchOrder: function () {
      // this.$emit('searchOrder', this.searchOrderNumber)
      if (this.searchOrderNumber === "") {
        this.$message.error("Nomor Pesanan Harus Diisi");
      } else {
        this.$router.push({
          name: "Order Detail",
          params: {
            orderNo: this.searchOrderNumber,
          },
        });
        // this.$router.replace("/main/dashboard");

        // window.location.reload();
      }
    },
    getDate(t) {
      const date = getDate(t);
      let res;
      if (date === "Invalid Date") {
        res = "-";
      } else {
        res = date;
      }
      return res;
    },
    replaceDetailNull(value) {
      if (value === "") {
        return "-";
      } else {
        return value;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.orderDetail {
  &-header {
    @extend .pb2;
    text-align: left;
    display: flex;
    // align-items: center;
    flex-direction: column;
    // justify-content: space-between;
  }
}

.header {
  background-color: $--color-border-gray;
  border-bottom: 1px solid $--color-border-gray;
  padding: 1% 2.5% 1% 2.5%;
  overflow: hidden;

  &-input {
    width: 25%;
    float: left;
    padding-top: 1%;
    padding-bottom: 1%;
    margin-right: 1%;
  }

  &-image {
    margin-right: 5%;
  }

  &-info {
    float: right;
    padding-top: 1.5%;
    padding-bottom: 1%;
  }
}
.label-text {
  @extend .f7;
  color: $--color-text-gray;
}
</style>
